import React from 'react';
import styled from 'styled-components';
import { useWindowSize } from 'hooks';
import { motion } from 'framer-motion';

function LogoRedLine() {
  const { windowWidth } = useWindowSize();
  return <Container custom={windowWidth} />;
}

const Container = styled(motion.div).attrs({
  initial: {
    width: 0
  },
  animate: (windowWidth) => ({
    width: windowWidth < 900 ? '100%' : 732
  }),
  transition: {
    delay: 0.2,
    duration: 0.6
  }
})`
  background-color: var(--connolly-red);
  height: 4px;
  margin: 15px auto 0;
`;

export default LogoRedLine;
